// hooks/useTasksCount.ts
import { useQuery } from 'react-query';
import axios from 'axios';
export const useTasksCount = () => {
    return useQuery(['tasksCount'], async () => {
        const response = await axios.get('/api/tasks/getDueAndOverdueCount');
        return response.data.data.count;
    }, {
        staleTime: 60000,
        refetchOnWindowFocus: true, // Refetch when user returns to tab
    });
};
